var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconShare = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 1.333c1.105 0 2 .896 2 2 0 1.105-.895 2-2 2-.518 0-.99-.196-1.345-.52L5.31 7.694c.015.1.023.202.023.307 0 .104-.008.207-.023.307l5.346 2.878c.355-.322.827-.518 1.344-.518 1.105 0 2 .895 2 2 0 1.104-.895 2-2 2s-2-.896-2-2c0-.105.008-.207.023-.307L4.677 9.481c-.355.323-.826.519-1.344.519-1.104 0-2-.895-2-2s.896-2 2-2c.518 0 .99.196 1.344.519l5.347-2.878c-.016-.1-.024-.203-.024-.308 0-1.104.895-2 2-2z",
    transform: "translate(-853 -177) translate(828 48) translate(25 129)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M12 12c.368 0 .667.298.667.667 0 .368-.299.666-.667.666-.368 0-.667-.298-.667-.666 0-.369.299-.667.667-.667zM3.333 7.333c.369 0 .667.299.667.667 0 .368-.298.667-.667.667-.368 0-.666-.299-.666-.667 0-.368.298-.667.666-.667zM12 2.667c.368 0 .667.298.667.666 0 .369-.299.667-.667.667-.368 0-.667-.298-.667-.667 0-.368.299-.666.667-.666z",
    transform: "translate(-853 -177) translate(828 48) translate(25 129)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconShare);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-share.75310328275290c6f47ea5c443301e32.svg";